{
    "header": {
        "language": "Taal",
        "logout": "Uitloggen"
    },
    "languages": {
        "en": "Engels",
        "nl": "Nederlands"
    }
}
